import { getSignature } from '@/utils/crypto'

export const getUsageParams = ({ indicator = 'all.servers', scope = 'system', date = '720h', userInfo = {} } = {}) => {
  const usageParams = {
    metric_query: [
      {
        model: {
          database: 'telegraf',
          measurement: 'usage',
          select: [
            [
              {
                type: 'field',
                params: [
                  indicator,
                ],
              },
              {
                type: 'last',
              },
            ],
          ],
        },
      },
    ],
    scope: scope,
    from: date,
    interval: date === '720h' ? '24h' : '6h',
    show_meta: true,
    unit: true,
  }
  // if (scope === 'project') {
  //   usageParams.project_id = userInfo.projectId
  // } else if (scope === 'domain') {
  //   usageParams.domain_id = userInfo.projectDomainId
  // }
  usageParams.signature = getSignature(usageParams)

  return usageParams
}

export const getTrendOptions = () => {
  return {
    xAxis: {
      show: false,
    },
    yAxis: {
      show: false,
    },
    legend: {
      show: false,
    },
    tooltip: {
      show: false,
    },
    grid: {
      containLabel: false,
      left: 10,
      top: 20,
      right: 10,
      bottom: 10,
    },
    series: {
      showSymbol: false,
      lineStyle: {
        width: 1,
        color: '#ADD1F3',
      },
      areaStyle: {
        color: '#EFF6FD',
      },
    },
  }
}
